<template>
    <v-dialog v-model="addCertificationDialog" refs="certificatemodal" :fullscreen='certificatefilevalue == null || editCertificateStatus == false ? false : true' persistent >
      <v-card>
        <v-card-title>
          <span class="headline">{{ title | translate }}</span>
        </v-card-title>
        <v-card-text>
            <v-form id="certificationform" ref="certificationform" class="mt-2">
                <v-row v-if="Object.keys(certificationerror).length > 0" class="certificationerrors">
                  <v-col cols="12">
                    <v-alert
                      dense
                      v-for="(v, k) in certificationerror"
                      :key="k"
                      outlined
                      type="error"
                    >{{ k }} {{ v }}</v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="editCertificateStatus == false" cols="12" sm="6" md="6">
                    <v-file-input
                      id="certificate_file"
                      name="cert_file"
                      ref="cert_file"
                      v-model="certificatefilevalue"
                      outlined
                      chips
                      required
                      :rules="certificateRules"
                      :label="'Select template' | translate"
                      @change="onFileSelected"
                    >
                      <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>  
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" v-if="certificatefilevalue || editCertificateStatus">
                    <v-select
                      v-model="selectedFont"
                      :items="fontValues"
                      item-value="value"
                      item-text="text"
                      autocomplete="off"
                      outlined
                      :label="'Font' | translate"
                      :rules="fontRules"
                      chips
                      small-chips
                      required
                    >
                      <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>  
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" v-if="certificatefilevalue || editCertificateStatus">
                    <v-select
                      v-model="fontsize"
                      :items="fontsizeValues"
                      autocomplete="off"
                      outlined
                      :label="'Font size' | translate"
                      :rules="fontsizeRules"
                      chips
                      small-chips
                      required
                    >
                      <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>  
                    </v-select>
                  </v-col>
                </v-row>


                <v-form id="dynamicfieldsform" ref="dynamicfieldsform" class="mt-2">
                  <v-row v-if="certificatefilevalue || editCertificateStatus">
                    <v-col cols="3">
                      <v-text-field
                          outlined
                          :label="'Label' | translate"
                          v-model="label"
                          name="label"
                          autocomplete="off"
                          :rules="labelvalidityRules"
                          required
                      >
                      <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>                            
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-select
                        v-model="customLabelTypes"
                        :items="labelTypes"
                        item-value="value"
                        item-text="text"
                        autocomplete="off"
                        outlined
                        :label="'Label types' | translate"
                        :rules="labeltypeRules"
                        chips
                        small-chips
                        required
                      >
                      <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template> 
                      </v-select>
                    </v-col>
                    <v-col cols="2" >
                      <v-btn color="primary" large class="mt-2"  @click="addLabel()">{{ 'Add label' | translate }}</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
               

                <v-row v-if="certificatefilevalue || editCertificateStatus">
                  <v-col cols="6">
                    <div class="text-center">
                      <v-pagination
                        v-model="currentPage"
                        :length="pageCount"
                      ></v-pagination>
                    </div>
                  </v-col>
                  <v-col cols="3" class="text-right">
                    <v-btn :disabled="previewButtonStatus" color="primary" @click="preview()">{{ 'Preview' | translate }}</v-btn>
                  </v-col>
                </v-row>


                <v-row v-if="certificatefilevalue || editCertificateStatus" >
                  <v-col cols="12" id="pdfManager">	
                    <div class="" id="selectorContainer">
                      <div class="col-fixed-240" id="parametriContainer">
                      </div>
                    <div class="col-fixed-605">
                      <div id="pageContainer" class="pdfViewer singlePageView dropzone nopadding" style="background-color:transparent">
                        <pdf id="the-canvas" :page="currentPage"   :src='cert_link'></pdf>
                      </div>
                    </div>
                    </div>
                  </v-col>
                </v-row>


            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCertificationBox()">{{ 'Close' | translate }}</v-btn>
          <v-btn color="blue darken-1" v-if="editCertificateStatus" text @click="updateCertification()">{{ 'Upload' | translate }}</v-btn>
          <v-btn color="blue darken-1" v-else text @click="addCertification()">{{ 'Upload' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import mixins from "@/mixins/mixins"
import pdf from 'vue-pdf'
import { mapGetters } from "vuex"
export default {
  name:"custompdf",
  created () {

  },
  mounted () {

  },

  components: {
    pdf,
  },
  mixins: [mixins],
  computed: {
    ...mapGetters(['curLanguage']),
    fontsizeValues () {
      let data = [];
      for(let i=8; i<=100; i++){
        data.push(i)
      }
      return data;
    },
  },
  data: function() {
      return {
        fontValues:[
          { value:'HurmeGeometricSans3-Light', text: 'HurmeGeometricSans3-Light', variant: ''},
          { value:'HurmeGeometricSans3-LightOblique', text: 'HurmeGeometricSans3-LightOblique' , variant: ''},
          { value:'HurmeGeometricSans3-Bold', text: 'HurmeGeometricSans3-Bold', variant: ''},
          { value:'HurmeGeometricSans3-BoldOblique', text: 'HurmeGeometricSans3-BoldOblique', variant: ''},
          { value: 'SourceSansPro-Regular', text:'SourceSansPro', variant: ''},
          { value: 'TimesNewRoman', text:'TimesNewRoman', variant: ''},
          { value: 'AvenirLTStd-Book', text:'AvenirLTStd-Book', variant: ''},
          { value: 'AvenirLTStd-Black', text:'AvenirLTStd-Black', variant: ''},
          { value: 'AvenirLTStd-Roman', text:'AvenirLTStd-Roman', variant: ''},
        ],
        cert_meta_data: {},
        cert_file: null,
        cert_link: null,
        label: null,
        labelTypes: [
          {
            text: 'Short text' ,value: 'short_text',
          },
          {
            text: 'Long text' ,value: 'long_text',
          },
          {
            text: 'Number' ,value: 'number',
          }
        ],
        customLabelTypes: null,
        selectedFont: null,
        pageCount: 0,
        currentPage: 1,
        pxtomm: 0.2645833333,
        certificatefilevalue: null,
        certificationerror: {},
        editCertificateStatus: false,
        fontsize:null,
        dragValues: this.dragDropValues,
        temp_file_id: null,
        previewButtonStatus: false,
        fontRules: [v => !!v || "Font is required"],
        fontsizeRules: [v => !!v || "Font size is required"],
        labelvalidityRules: [v => !!v || "Label is required"],
        labeltypeRules : [v => !!v || "Label type is required"],
        certificateRules: [
          v => !!v || 'Template is required',
          v => (v && v.size > 0) || 'Template is required',
        ],

      }
  },
  props : {
    addCertificationDialog: Boolean,
    dragDropValues: Array,
    temp_id: Number,
    previewSlug: String,
    updateSlug: String,
    getData: String,
    temp_validity: Number,
    title: String,
    editTemplate: Object,
    editSlug: String
  },
  watch: {
    currentPage(newValue, oldValue){
      if(newValue !== oldValue){
        this.getCoordinates(oldValue)
        this.renderizzaPlaceholder(newValue)
      }
    },
    editTemplate: {
      immediate: true, 
      handler (newVal) {
        if(newVal != undefined && Object.keys(newVal).length > 0) {
          this.temp_file_id = newVal.temp_file_id;
          this.editCertificateBox(this.editSlug,newVal)
        }
      }
  }
  },  
  methods: {
    closeBox () {
      this.$emit('closeTemplateBox');
    },
    addLabel() {
      if (this.$refs.dynamicfieldsform.validate()) {
        this.dragValues.push({fieldName: this.customLabelTypes, label:this.label, id: Math.random() })
        this.getCoordinates(this.currentPage);
        this.renderizzaPlaceholder(this.currentPage)
        this.$emit('addCustomLabel',this.dragValues);
        this.label = ''
        this.customLabelTypes = ''
        this.$refs.dynamicfieldsform.resetValidation()
        this.$refs.dynamicfieldsform.reset()   
      }
    },
    onFileSelected() {
      this.cert_meta_data = {}
      this.cert_file = this.certificatefilevalue == null ? null : document.getElementById("certificate_file").files[0]
      this.cert_link = this.cert_file == null ? null : URL.createObjectURL(this.cert_file)

      if(this.cert_link !== null ){
        let loadingTask = pdf.createLoadingTask(this.cert_link);

        loadingTask.promise.then(pdf => { 
            this.pageCount = pdf.numPages 
            if(this.certificatefilevalue !== null){
              this.fontsize = null
              this.selectedFont = null
              this.pdfDragSetup()
              this.renderizzaPlaceholder()
            }
          });
      }
    }
  }
}
</script>
<style>
#messageContainer{
	display:none;
}

#outer-dropzone {
  height: 140px;

  touch-action: none;
}

#inner-dropzone {
  height: 80px;
}

.dropzone {
  background-color: #ccc;
  border: dashed 4px transparent;
  border-radius: 4px;
  margin: 10px auto 30px;
  padding: 10px;
  width: 100%;
  transition: background-color 0.3s;
}

.drop-active {
  border-color: #aaa;
}

.drop-target {
  background-color: #29e;
  border-color: #fff;
  border-style: solid;
}

.drag-drop {
  display: inline-block;
  position:absolute;
  z-index:999;
  min-width: 40px;
  padding: 0em 0.5em;
  padding-left:0;
  color: #fff;
  background-color: #29e;
  border: none;

  -webkit-transform: translate(0px, 0px);
          transform: translate(0px, 0px);

  transition: background-color 0.3s;
  line-height: 10px;
  padding-right: 0 !important;
  padding-left: 5px !important;
}

.drag-drop.can-drop {
  color: #000;
  background-color: transparent;
  opacity:0.9;
  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";

  /* IE 5-7 */
  filter: alpha(opacity=90);

  /* Netscape */
  -moz-opacity: 0.9;

  /* Safari 1.x */
  -khtml-opacity: 0.9;
}

.nopadding {
   padding: 0 !important;
   margin: 0 !important;
}

.circle {
	width: 10px;
    height: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #323c3c;
    float: left;
	display: inline-block;
    margin-top: 1px;
    margin-right: 2px;
}

.dropped-out{
	display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    width:200px;
    color: black;
}

.col-fixed-240{
    width:240px;
    height:100%;
    z-index:1;
}

.col-fixed-605{
    margin-left:240px;
    width:793.7007874px !important;
    height:100%;
}

.page-item{
	cursor:pointer;
}

.pager{
	margin-bottom:30px !important;
	margin-top:0px !important;
	margin-bottom: -31px !important;
}

.drag-drop.dropped-out .descrizione {
    font-size: 12px !important;
}

#the-canvas{
  height:1122.519685px !important;
  width: 793.7007874px;
}

canvas{
  height:1122.519685px !important; 
  width: 793.7007874px !important;
  border: 1px solid #000;
}

</style>